import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import {Swiper, Navigation, Pagination, Autoplay, Keyboard, Thumbs, Grid} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

// Chart.js
import {
    Chart,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LineController,
    PointElement
} from "chart.js";

// Register the components
Chart.register(
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LineController,
    PointElement
);

Chart.defaults.font.family = 'Yekan Bakh';

window.ChartJS = Chart;

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 10000,
    timerProgressBar: true
});

// AOS
import AOS from 'aos';

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

const setupApp = ()=>
{
    lazySizes.init();

    refreshFsLightbox();

    AOS.init()

    const blogSwiper = new Swiper('#blog-swiper', {
        modules: [Navigation],
        slidesPerView: 1.4,
        direction:'horizontal',
        spaceBetween:20,
        // autoplay : true,
        // loop: true,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        // 'xs': '470px',
        // 'sm': '640px',
        // // => @media (min-width: 640px) { ... }

        // 'md': '768px',
        // // => @media (min-width: 768px) { ... }

        // 'lg': '1024px',
        // // => @media (min-width: 1024px) { ... }

        // 'xl': '1280px',
        // // => @media (min-width: 1280px) { ... }

        // '2xl': '1536px',
        // // => @media (min-width: 1536px) { ... }

        breakpoints:{
            470:{
                slidesPerView:2.2
            },
            768:{
                slidesPerView:3.5
            },
            1024:{
                slidesPerView:4,
                spaceBetween:30,
            },

        }
    });

    const brandsSwiper = new Swiper('#brandsSwiper', {
        modules: [Autoplay],
        slidesPerView: 3,
        spaceBetween: 40,
        loop: true,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        speed: 5000,
        breakpoints: {
            400: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 3.2,
            },
            1280: {
                slidesPerView: 7,
            },
        },
    });


    const header = document.querySelector('#header');
    const specialAside = document.querySelector('#special-offer-aside');
    const headerHeight = header.offsetHeight;
    let specialAsideHeight = 100;

    if( specialAside )
        specialAsideHeight = specialAside.offsetHeight;
    let prevScroll = window.scrollY;
    let bottom = 0;
    let threshold = 0;

    if( specialAside )
        bottom = specialAside.getBoundingClientRect().bottom

    window.onscroll = () => {

        const currentScroll = window.scrollY;
        threshold =  bottom ;

        if (currentScroll < threshold){
            if( specialAside )
                specialAside.classList.remove('fixed');
        }
        if (prevScroll > currentScroll) {

            // header.classList.remove('-translate-y-full');
            if( currentScroll > threshold) {
                if (window.innerWidth > 1024){
                    if( specialAside )
                        specialAside.style.top = headerHeight + "px";
                }
                else {
                    if( specialAside )
                        specialAside.style.transform = "translateY(" + 0 + "px)";
                }
            }

        } else {
            // header.classList.add('-translate-y-full');

            if( currentScroll > threshold) {
                let viewPortWidth = window.innerWidth;
                if (viewPortWidth > 1024){

                    if( specialAside ) {
                        specialAside.classList.add('fixed')
                        specialAside.style.top = 0 + "px";
                    }
                }
                else {
                    if( specialAside && specialAsideHeight  ) {
                        specialAside.classList.add('hidden');
                        specialAside.style.transform = "translateY(-" + (headerHeight + specialAsideHeight) + "px)";
                        specialAside.classList.add('fixed');
                        specialAside.style.top = headerHeight + "px";
                        specialAside.classList.remove('hidden');
                    }
                }
                // translate element up in the amount of header height + self height
            }
        }

        prevScroll = currentScroll;
    }
};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

// window.addEventListener("livewire:navigated", function(){
//     window.scrollTo({top: 0, behavior: 'smooth'});
// })
